import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { FaBuilding, FaMapMarkerAlt, FaPhone, FaEnvelope, FaGavel, FaLink, FaCopyright, FaBalanceScale } from 'react-icons/fa'

const Impressum = () => {
  const { t } = useTranslation()

  const sections = [
    {
      icon: FaBuilding,
      title: t('impressum.companyInfo'),
      content: (
        <div className="space-y-3 text-base text-gray-300">
          <p className="text-lg font-semibold text-white">KennzeichenPro24 GmbH</p>
          <div className="flex items-start gap-3">
            <FaMapMarkerAlt className="w-4 h-4 text-primary-400 mt-1 flex-shrink-0" />
            <div>
              <p>Zollstock 15</p>
              <p>37081 Göttingen-Grone</p>
              <p>Niedersachsen, Deutschland</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <FaPhone className="w-4 h-4 text-primary-400 flex-shrink-0" />
            <a href="tel:+4955149203480" className="hover:text-primary-400 transition-colors">+49 (0) 551 49203480</a>
          </div>
          <div className="flex items-center gap-3">
            <FaEnvelope className="w-4 h-4 text-primary-400 flex-shrink-0" />
            <a href="mailto:info@kennzeichenpro24.de" className="hover:text-primary-400 transition-colors">info@kennzeichenpro24.de</a>
          </div>
        </div>
      ),
      delay: 0.2,
    },
    {
      icon: FaGavel,
      title: t('impressum.liabilityContent'),
      content: <p className="text-base text-gray-300 leading-relaxed">{t('impressum.liabilityContentText')}</p>,
      delay: 0.3,
    },
    {
      icon: FaLink,
      title: t('impressum.liabilityLinks'),
      content: <p className="text-base text-gray-300 leading-relaxed">{t('impressum.liabilityLinksText')}</p>,
      delay: 0.4,
    },
    {
      icon: FaCopyright,
      title: t('impressum.copyright'),
      content: <p className="text-base text-gray-300 leading-relaxed">{t('impressum.copyrightText')}</p>,
      delay: 0.5,
    },
    {
      icon: FaBalanceScale,
      title: t('impressum.disputeResolution'),
      content: (
        <div className="text-base text-gray-300 leading-relaxed space-y-2">
          <p>{t('impressum.disputeResolutionText')}</p>
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-primary-400 hover:text-primary-300 transition-colors underline underline-offset-2"
          >
            https://ec.europa.eu/consumers/odr
          </a>
        </div>
      ),
      delay: 0.6,
    },
  ]

  return (
    <div className="bg-dark-950 min-h-screen py-12 relative overflow-hidden">
      <div className="fixed inset-0 bg-grid-pattern opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-mesh opacity-30"></div>

      <div className="container-custom relative z-10">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-10"
          >
            <h1 className="text-4xl md:text-5xl font-black mb-4">
              <span className="text-gradient">{t('impressum.title')}</span>
            </h1>
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary-500 to-transparent mx-auto"></div>
          </motion.div>

          <div className="space-y-6">
            {sections.map((section) => (
              <motion.section
                key={section.title}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: section.delay, duration: 0.6 }}
                className="card-hover"
              >
                <h2 className="text-xl font-bold mb-4 text-gradient flex items-center gap-3">
                  <section.icon className="w-5 h-5 text-primary-400" />
                  {section.title}
                </h2>
                {section.content}
              </motion.section>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Impressum
